import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { WidgetsService } from '../../widgets.service';
import { SearchItem } from '../../../../entities';
import { AppService } from '../../../../app.service';
import { FleetCondition } from '../../widgets.model';
import { Subscription } from 'rxjs/Subscription';
import { NotificationsService } from 'angular2-notifications';
import { WidgetsEnlargedComponentComponent } from '../widgets-enlarged-component/widgets-enlarged-component.component';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '../../../../../app/translate';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'inspections-performed-widget',
  templateUrl: './inspections-performed-widget.component.html',
  styleUrls: ['./inspections-performed-widget.component.scss']
})
export class InspectionsPerformedWidgetComponent implements OnInit, OnDestroy {
  @Input() chartid: string;
  
  @Input() passedDataSource : any;
  @Input() isInPopup: boolean = false;
  width: number = 280;
  height: number = 180;
  type: string = 'msarea';
  dataFormat: string = 'json';
  dataSource: any;
    fleetCondition: FleetCondition;
    //widgetTriggerSubscription: Subscription;
  subscriptions: Subscription[] = [];
  emptySearchSelectionQuery: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: "Evaluation X" }];
  loading: boolean = true;
  noData: boolean = false;
  userLanguage = 'english';
  translateSubscription: Subscription;
  enableTab:boolean=false
  constructor(private _widgets: WidgetsService,private _translate: TranslateService,private ref: ChangeDetectorRef,
      private _app: AppService,
    private _notifications: NotificationsService,
    private _dialog: MatDialog) {
    this.dataSource = {
      "chart": {
        "theme": "fusion",
        "showValues": "0",
        "canvasPadding": "0",
        "drawCrossLine": "1",
        "crossLineColor": "#262626",
        "paletteColors": "#2290F9,#26F1D4",
        "showBorder": "0",
        "crossLineAlpha": "50",
        "numberSuffix": ""
      },
      "categories": [{
        "category": [{
          "label": this.Translate('Jan'),
        }, {
            "label": this.Translate('Feb')
        }, {
            "label": this.Translate('Mar')
        }, {
            "label": this.Translate("Apr")
        }, {
          "label": this.Translate("May")
        }, {
          "label": this.Translate("Jun")
        }, {
          "label": this.Translate("Jul")
        }, {
          "label": this.Translate("Aug")
        }, {
          "label": this.Translate("Sep")
        }, {
          "label":this.Translate( "Oct")
        }, {
          "label": this.Translate("Nov")
        }, {
          "label": this.Translate('Dec')
        }]
      }],
      "dataset": [{
        "seriesname": "2017",
        "alpha": "80",
        "data": [{
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }]
      }, {
        "seriesname": "2018",
        "alpha": "60",
        "data": [{
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }]
      }]
    };
  }

    ngOnInit() {
      this.enableTab=this._app.getEnableSearch()
      if(this.passedDataSource != null ){
        console.log("received   ", this.passedDataSource);
        this.subscriptions.push(         
          this.passedDataSource.subscribe(r=>this.loadDataToGraph(r))
          //  this.passedDataSource.forEach(c=>this.pushResult(c))
        );
        
        this.loading = false;
        if(this.isInPopup){
          this.width = 460;
          this.height = 360;
        }
      }
      else{
        this.loadWidget(this._app.getLastSelectionSearchItems());
      }
      this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      if ( s!= undefined &&  !s.closed)
        s.unsubscribe();
      });
      //this.widgetTriggerSubscription.unsubscribe();
      this.translateSubscription.unsubscribe();
  }
  updateUserLang(lang: string) {
    this.userLanguage = lang;
    console.log("language", this.userLanguage)
    this.ref.detectChanges();
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  loadWidget(searchSelection: SearchItem[]) {
    this.loading = true;
    this.subscriptions.push(this._widgets.getInspectionsPerformed(searchSelection).subscribe(r => {
      this.dataSourceToPass = Observable.of(r);
     this.loadDataToGraph(r);
    }, error => { this._notifications.error('Error', 'Unable to load inspections performed graph. '); console.log(error); }));
  }

  dataSourceToPass : any;

  openWithANewPopup() {
   
    let dialogRef = this._dialog.open(WidgetsEnlargedComponentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        chartId: this.chartid,
        dataSource: this.dataSourceToPass,
        chartTitle: "Inspections Performed",     
      }
    });

    dialogRef.afterClosed().subscribe(r => {

    });

  }


  loadDataToGraph(r){
    this.dataSource.dataset[0].seriesname = r[0].Year;
    this.dataSource.dataset[1].seriesname = r[1].Year;
    let totalInspections = 0;
    for (let i = 0; i < 12; i++) {
      this.dataSource.dataset[0].data[i].value = r[0].InspectionCountMonth[i];
      this.dataSource.dataset[1].data[i].value = r[1].InspectionCountMonth[i];
      totalInspections += r[0].InspectionCountMonth[i] + r[1].InspectionCountMonth[i];
    }
    if (totalInspections == 0)
      this.noData = true;
    else
      this.noData = false;
    this.loading = false;
  }

}
